<script>
export default {
  name: "FormField",
  props: {
    options: {
      default: "bool",
      type: [String, Array],
    },
    optionName: {
      default: "",
      type: String,
    },
    disabled: {
      type: Array,
    },
    noEffect: {
      type: Array,
    },
    value: {
      default: false,
      type: [String, Boolean, Number],
    },
    description: {
      default: "",
      type: String,
    },
  },
};
</script>
<template>
  <sui-form-field inline>
    <template v-if="options !== 'bool' && options.length === 2">
      <label>{{ optionName }}</label>
      <sui-form-field
        v-for="option in options"
        :key="option.value"
        class="radio"
        :class="
          disabled.includes(option.value) || noEffect.includes(option.value)
            ? 'invalid'
            : ''
        "
      >
        <sui-checkbox
          radio
          :input-value="value === option.value"
          @change="
            $emit('change', option.value, disabled.includes(option.value))
          "
        >
          <div>{{ option.text }}</div>
          <span class="description">{{ option.description }}</span>
        </sui-checkbox>
      </sui-form-field>
      <p class="description">{{ description }}</p>
      <sui-divider />
    </template>
    <template v-else-if="options !== 'bool'">
      <label>{{ optionName }}</label>
      <sui-dropdown
        :text="options.find((o) => o.value === value).text"
        fluid
        selection
      >
        <sui-dropdown-menu>
          <sui-dropdown-item
            v-for="option in options"
            :key="option.value"
            :selected="value === option.value"
            :class="
              disabled.includes(option.value) || noEffect.includes(option.value)
                ? 'invalid'
                : ''
            "
            @select="
              $emit('change', option.value, disabled.includes(option.value))
            "
          >
            <div>
              <h5>{{ option.text }}</h5>
              <span class="description">{{ option.description }}</span>
            </div>
          </sui-dropdown-item>
        </sui-dropdown-menu>
      </sui-dropdown>
      <p class="description">{{ description }}</p>
      <sui-divider />
    </template>
    <template v-else-if="options === 'bool'">
      <sui-checkbox
        :label="optionName"
        :input-value="value"
        :class="
          disabled.includes(!value) || noEffect.includes(!value)
            ? 'disabled'
            : ''
        "
        @change="$emit('change', $event, disabled.includes($event))"
      />
      <p class="description">{{ description }}</p>
      <sui-divider />
    </template>
  </sui-form-field>
</template>

<style>
.ui.checkbox.disabled label {
  cursor: pointer !important;
}

.ui.checkbox.disabled.indeterminate label::after {
  content: "\E801";
  font-size: 12px;
  opacity: 0.45;
  cursor: pointer;
}
</style>

<style scoped>
.field.radio {
  margin-bottom: 2px;
  margin-left: 5px;
}
.description {
  font-weight: initial !important;
  margin-top: 10px !important;
  color: #535353 !important;
}
.invalid {
  opacity: 0.45;
}
</style>
